<template>
    <div class="page container" data-page="auth"></div>    
</template>

<script>
export default {
    name: 'Auth',

    beforeMount(){
        if(this.$store.state.currentUser !== null){
            
            let userUid = this.$store.state.currentUser.uid

            if(this.$route.query.code){

                let code = this.$route.query.code

                this.$router.push('/user/'+ userUid + '?authCode=' + code)

            }else if(this.$route.query.remove){
                this.$router.push('/user/'+ userUid + '?remove=true')
            }else if(this.$route.query.delete){
                this.$router.push('/user/'+ userUid + '?delete=true')
            }
        }else{
            this.$router.push('/')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/Auth.vue